import { BsPinFill } from 'react-icons/bs';
import { PlatformSelect } from '@/components/PlatformSelect';
import { useCurrentUserContext } from '@/contexts';
import { useExportPlatforms } from '@/features/interactions/lib/useExportPlatforms';
import { useSetPreferredPlatform } from '@/hooks/useSetPreferredPlatform';
import { useIntegrations } from '@/pages/Schedule/hooks/useIntegrations';
import { PlatformTypes } from '@/types/gql.generated';
import { Icon, useDisclosure, useToast } from '@/ui';
import { ensurePlatform } from '@/utils/platformLib';

const PLATFORMS = [
  PlatformTypes.GoogleIntegration,
  PlatformTypes.AppleIcs,
  PlatformTypes.OutlookLink,
  PlatformTypes.OfficeLink,
  PlatformTypes.OtherIcs,
];

export const PlatformPicker = () => {
  const { currentUser } = useCurrentUserContext();
  const { data: integrations = [] } = useIntegrations();
  const { setPreferredPlatform } = useSetPreferredPlatform();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const platforms = useExportPlatforms(PLATFORMS);
  const toast = useToast();

  const selectedPlatform = currentUser?.preferredPlatform
    ? ensurePlatform(currentUser.preferredPlatform, integrations)
    : null;

  const handleChange = (platform: PlatformTypes) => {
    setPreferredPlatform(platform, {
      onSuccess: () => onClose(),
      onError: () => {
        toast.error(
          'Whoops! We had some trouble setting your preferred Magic calendar platform. Please try again.'
        );
      },
    });
  };

  return (
    <PlatformSelect
      isOpen={isOpen}
      matchWidth
      platforms={platforms}
      value={selectedPlatform}
      renderItemExtra={(platform) =>
        platform === selectedPlatform ? (
          <Icon as={BsPinFill} color="purple.600" />
        ) : null
      }
      onChange={handleChange}
      onClose={onClose}
      onOpen={onOpen}
    />
  );
};
